import { createSelector } from 'reselect';
import { parseISO } from 'date-fns';

import { reportsReservations as reportsReservationsEntity } from 'store/saga/entities/bound';
import { sortOptionsMap } from './Reservations.constants';

// entity fields

export const selectReportsReservationsIsLoading = state =>
  !reportsReservationsEntity.loaded(state) || reportsReservationsEntity.loading(state);

const selectReportsReservationsIsLoaded = state => reportsReservationsEntity.loaded(state);
const selectReportsReservationsData = state => reportsReservationsEntity.data(state);
export const selectReportsReservations = createSelector(
  selectReportsReservationsIsLoaded,
  selectReportsReservationsData,
  (isLoaded, reportsReservationsData) =>
    isLoaded
      ? {
          ...reportsReservationsData,
          report: reportsReservationsData.report.map(reservation => ({
            ...reservation,
            dateTime: parseISO(`${reservation.classDate} ${reservation.startTime}`),
          })),
        }
      : {}
);

// reducer fields

export const selectReportsReservationsControls = state => state.reportsReservations;

export const selectReportsReservationsSortOption = createSelector(
  selectReportsReservationsControls,
  ({ sortField, sortDirection }) => sortOptionsMap[`${sortField}_${sortDirection}`]
);
